export {default} from './ControllPanel'



// WEBPACK FOOTER //
// ./src/UI/ControllPanel/index.js